import React from 'react';
import './home.css';

import logo2 from '../assets/logo2.svg';
import hero from '../assets/illus1.svg';
import illus2 from '../assets/illus2.svg';
import star from '../assets/star.svg';
import concert from '../assets/img1.png';
import concert3 from '../assets/img2.webp';
import concert4 from '../assets/img3.jpg';
import concert5 from '../assets/img4.jpg';

import Navbar from '../components/layout/header';
import TitleBlock from '../components/common/title';
import Button from '../components/common/button';
import CategoryCard from '../components/common/category';
import CategoryChip from '../components/common/chip';
// import EventCard from '../components/common/card';
import Review from '../components/common/card2';
import Featured from '../components/common/featured';
import Preloader from '../components/layout/preloader';
import Footer from '../components/layout/footer';

import { useTranslation } from 'react-i18next';
import Form1 from '../sections/form';
import Events from '../sections/events';

const Home = () => {
    const { t } = useTranslation();

    return (
        <>
            <Preloader />
            <Navbar />

            <main>

                {/* HERO */}
                <section className="heroFlex">
                    <div className="heroCont">
                        <TitleBlock
                            img={logo2}
                            class="title1"
                            heading={t('home.hero.heading')}
                            subheading={t('home.hero.subheading')}
                        />
                        <div className="btnFlex">
                            <Button class="btn2" cta={t('home.hero.cta1')} />
                            <Button class="btn1" cta={t('home.hero.cta2')} />
                        </div>
                    </div>
                    <img className='heroImg moveIn' src={hero} alt="" />
                </section>

                <div className="checkeredSeparator"></div>

                {/* CATEGORIES */}
                <section id='categories' className="container">
                    <TitleBlock
                        img={star}
                        class="title1 title2"
                        heading={t('home.categories.heading')}
                        subheading={t('home.categories.subheading')}
                    />

                    <div className="categoriesFlex">
                        <CategoryCard img={concert} title={t('home.categories.theater')} />
                        <CategoryCard img={concert3} title={t('home.categories.concerts')} />
                        <CategoryCard img={concert5} title={t('home.categories.workshops')} />
                        <CategoryCard img={concert4} title={t('home.categories.conferences')} />
                    </div>
                </section>

                <div className="checkeredSeparator"></div>

                {/* ABOUT */}
                <section id="about" className="heroFlex">
                    <div className="heroCont">
                        <TitleBlock
                            img={star}
                            class="title1"
                            heading={t('home.about.heading')}
                            subheading={t('home.about.subheading')}
                        />
                        <p>{t('home.about.text')}</p>
                    </div>
                    <img className='heroImg aboutUsImg' src={illus2} alt="" />
                </section>

                <div className="checkeredSeparator"></div>

                {/* EVENTS */}
                <section id='events' className="container">
                    <TitleBlock
                        img={star}
                        class="title1 title2"
                        heading={t('home.events.heading')}
                        subheading={t('home.events.subheading')}
                    />
                    <div className="chipsFlex">
                        <CategoryChip class="active" title={t('home.categories.concerts')} />
                        <CategoryChip class="inactive" title={t('home.categories.theater')} />
                        <CategoryChip class="inactive" title={t('home.categories.conferences')} />
                        <CategoryChip class="inactive" title={t('home.categories.workshops')} />
                    </div>

                    <div className="categoriesFlex">
                        <Events />
                    </div>
                </section>

                <div className="checkeredSeparator"></div>

                {/* FEEDBACK */}
                <section id="feedback" className="container">
                    <TitleBlock
                        img={star}
                        class="title1 title2"
                        heading={t('home.feedback.heading')}
                        subheading={t('home.feedback.subheading')}
                    />

                    <div className="categoriesFlex">
                        <Review
                            quote={t('home.feedback.quote')}
                            name="John Doe"
                            rating="5"
                        />
                    </div>
                </section>

                <div className="checkeredSeparator"></div>
                {/* SUBSCRIBE */}
                {/* 5 */}
<section id='events' className="container">
    <TitleBlock
        img={star}
        class="title1 title2"
        heading={t('home.featured.heading')}
    />
    <Featured
        title={t('home.events.sampleTitle')}
        location={t('home.events.location')}
        date={t('home.events.date')}
        time="2:00pm"
        price="2000"
        img={concert}
    />
</section>


{/* BOOK */}
<section id='book' className='container moveIn scrollAnimate'>
    <Form1 />
</section>

{/* SUBSCRIBE */}
<section id='subscribe' className='container form2Cont moveIn scrollAnimate'>
    <TitleBlock
        img={star}
        class="title1 title2"
        heading={t('home.subscribe.heading')}
        subheading={t('home.subscribe.subheading')}
    />

    <form className='form1 form2' action="#">
        <div className="formLeft">
            <input type="text" placeholder={t('home.subscribe.email')} />

            <button type='submit' className='btn1 btn4'>
                {t('home.subscribe.cta')}
            </button>
        </div>
    </form>
</section>

            </main>

            <Footer />
        </>
    );
};

export default Home;